module.exports = __webpack_public_path__ + "fonts/26510a5.woff2";